import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'frameRate';

export class FrameRate extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
